import React from 'react';

function CricketIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="m22.5387 1.39187c-.5701-.566215-1.4487-.512618-1.9617.12046l-3.3486 4.14556-1.5843-.2733c-.1667-.02812-.3272.03662-.4369.17353l-10.4175 12.89728c-.08911.1104-.1327.2574-.1212.4054.1921 2.4156 1.89514 4.1392 4.06909 4.1392.03402 0 .06995 0 .10492-.0011.13365-.0031.26108-.0684.35115-.1799l10.41804-12.89669c.1092-.13532.1499-.32318.1063-.49883l-.4211-1.71352 3.3496-4.14661c.5111-.63202.4618-1.60685-.1078-2.17148z"/>
      <path d="m5.79967 14.0027c1.01192-1.2334.91611-3.1345-.2153-4.23987-1.13141-1.10299-2.87159-.99727-3.88297.23552-.18031.21965-.31541.46805-.42791.72715-.02207.0364-.03499.0751-.04898.1151-.16094.4152-.243829.8639-.22068 1.3267.04037.8.36547 1.5359.91288 2.0704.52426.5115 1.17931.7623 1.83329.7623.75517 0 1.50711-.336 2.04967-.9973z"/>
    </svg>
  );
}

export default CricketIcon;